import { RootState } from "common";
import { createSelector } from "reselect";

const selectBranchState = (state: RootState) => state.Branch;

const selectBranches = createSelector(
  selectBranchState,
  (state) => state.branches
);

const selectUserBranchOptions = createSelector(
  selectBranchState,
  (state) => state.userBranchOptions
);

const selectBranchOptionsLoading = createSelector(
  selectBranchState,
  (state) => state.branchOptionsLoading
);

const selectCurrentBranch = createSelector(
  selectBranchState,
  (state) => state.currentBranch
);

const selectDefaultBranch = createSelector(
  selectBranchState,
  (state) => state.defaultBranch
);

const selectCurrentBranchId = createSelector(
  selectBranchState,
  (state) => state.currentBranch.id
);

const selectDoNotShowAgain = createSelector(
  selectBranchState,
  (state) => state.doNotShowAgain
);

export const selectors = {
  selectBranches,
  selectCurrentBranchId,
  selectDefaultBranch,
  selectUserBranchOptions,
  selectBranchOptionsLoading,
  selectCurrentBranch,
  selectDoNotShowAgain,
};
